// API: пусто = запросы через vite proxy (/api → backend), без CORS
const rawApi = import.meta.env.VITE_API_URL;
export const API_BASE_URL = (rawApi === undefined ? '' : rawApi).replace(/\/$/, '');

// Статика: пусто = /static через vite proxy (тот же origin, без CORS)
const rawAsset = import.meta.env.VITE_ASSET_BASE_URL;
export const ASSET_BASE_URL = (rawAsset === undefined ? '' : rawAsset).replace(/\/$/, '');
